<template>
    <v-dialog
        max-width="290"
        @click:outside="dismiss"
        @keydown.esc="dismiss"
        :value="orderSuccess"
        transition="fab-transition"
        scrollable
    >
        <v-card>
            <v-card-title class="headline">
                Success! <br>You're Order #{{ orderSuccess.orderId }}
            </v-card-title>

            <v-card-text>
                <p>We're prepping your order, here's a gif!</p>
                <v-img
                    :src="orderSuccess[format]"
                    @error="format = 'gif'"
                    :height="$vuetify.breakpoint.height > 500 ? '200' : '150'"
                    class="my-1"
                >
                    <template #placeholder>
                        <v-skeleton-loader
                            type="image"
                            loading
                        />
                    </template>
                </v-img>
                <div class="d-flex justify-space-between align-content-end">
                    <small>{{ orderSuccess.creator ? `GIF by ${orderSuccess.creator}` : '' }}</small>
                    <v-img src="@/assets/images/giphy.png" max-width="40" contain />
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="primary"
                    depressed
                    @click="dismiss"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import * as types from '@/store/mutation-types';

export default {
  name: 'DialogSuccess',

  data: () => ({
    format: 'webp',
  }),

  computed: {
    orderSuccess: {
      get() {
        return this.$store.state.basket.orderSuccess;
      },
      set() {
        this.$store.commit(types.ORDER_SUCCESS, '');
      },
    },

    navShowDialogSuccess() {
      return this.$route.meta.showDialogSuccess;
    },
  },

  watch: {
    orderSuccess(newValue) {
      if (!newValue) {
        this.format = 'webp';
      }

      if (typeof newValue === 'object') {
        this.$router.replace({ name: 'success' });
      } else {
        // if they click back in their browser the route wont be success anymore and hence
        // only need to take them back one in history, other we take them back 2.
        let backNumber = this.$route.name === 'success' ? -2 : -1;

        // if on desktop they never had the basket
        if (this.$vuetify.breakpoint.mdAndUp) {
          backNumber++;
        }

        if (backNumber !== 0) {
          this.$router.go(backNumber);
        }
      }
    },

    navShowDialogSuccess(newValue) {
      if (!newValue) {
        this.dismiss();
      }
    },
  },

  methods: {
    dismiss() {
      this.orderSuccess = false;
    },
  },
};
</script>

<style>

</style>
